import * as Yup from 'yup';

export const validationFormStepThree = (props) =>
	Yup.object({
		password: Yup.string()
			.nullable()
			.min(8, props.t('common:passwordRequired'))
			.required(props.t('common:passwordRequired')),
		passwordConfirmation: Yup.string()
			.nullable()
			.required(props.t('common:passwordConfirmationRequired'))
			.oneOf([Yup.ref('password'), null], props.t('common:passwordsMatch')),
	});
